import { render, staticRenderFns } from "./DialogPontosVenda.vue?vue&type=template&id=7ba7f672&scoped=true&"
import script from "./DialogPontosVenda.vue?vue&type=script&lang=js&"
export * from "./DialogPontosVenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba7f672",
  null
  
)

export default component.exports